import React from "react";
import { SignIn } from "@clerk/clerk-react";
import { useLocation } from "react-router-dom";
import { getRedirectUrl } from "components/utils/getRedirectUrl";
import { Role } from "types";
import { getAllNestedParams } from "components/utils/getNestedQueryParams";

const SignInWithClerk: React.FC = () => {
  const location = useLocation();
  const signUpUrl = getRedirectUrl("/sign-up");
  const { search, hash } = location;
  const searchString = hash.replace(/^#\/?/, "");

  const outerUrl = new URL(searchString, window.location.origin);
  const redirectUrlEncoded = outerUrl.searchParams.get("redirect_url");

  const nestedParams = redirectUrlEncoded
    ? getAllNestedParams(searchString, "redirect_url")
    : {};

  const appParam = nestedParams.app;

  const forceRedirectUrl = `/user-provisioning${search}${hash}`;

  return (
    <div className="flex justify-center items-center min-h-[100vh] z-[9999]">
      <SignIn
        signUpUrl={signUpUrl}
        forceRedirectUrl={forceRedirectUrl}
        appearance={{
          elements: {
            cardBox: "w-[100%] sm:w-[70%] md:w-[40vw] max-w-[80vw]",
            formButtonPrimary:
              "bg-primary-700 hover:bg-primary-700 font-bold rounded-md px-4 py-2",
            identityPreviewText: "text-primary-700 font-medium",
            backLink: "font-medium",
            footerActionLink:
              "text-primary-700 hover:text-primary-800 font-semibold",
            footerActionText: "text-gray-600 font-normal",
            footer: appParam === Role.VirtualDataRoom ? "hidden" : "",
          },
        }}
      />
    </div>
  );
};

export default SignInWithClerk;
